var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLssSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7011 24.1369L28.9369 21.3771L18.2967 32L0 13.7331L5.87951 7.86311L8.64376 10.6229L19.2839 0L37.5806 18.2669L31.7011 24.1369ZM11.408 21.618L3.51016 13.7331L5.87951 11.3676L8.64376 14.1273L19.2839 3.50445L24.4175 8.6297L22.0482 10.9952L19.2839 8.23547L11.0131 16.4928L13.7773 19.2526L11.408 21.618ZM13.1631 23.3703L18.2967 28.4955L28.9369 17.8727L31.7011 20.6324L34.0705 18.2669L26.1726 10.3819L23.8032 12.7474L26.5675 15.5072L18.2967 23.7646L15.5324 21.0048L13.1631 23.3703ZM18.2967 20.2601L14.5233 16.4928L19.2839 11.7399L23.0573 15.5072L18.2967 20.2601Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLssSmall);
export default __webpack_public_path__ + "static/media/lss_small.1a4323f88335581b59c1ce3643bda504.svg";
export { ForwardRef as ReactComponent };